<template>
  <div class="orglist">
    <PackageCard v-for="item in list" :item="item" :key="item.id"  />
    <!-- <p class="no-more" v-if="noMoreData">没有更多套餐了</p> -->
  </div>
</template>

<script>
import PackageCard from './PackageCard'

export default {
  name: 'PackageListNew',
  components: {
    PackageCard
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    noMoreData: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="less" scoped>
.orglist {
  padding: 0 12px;
  margin-bottom: 25px;
  // .no-more {

  // }
}
</style>
